(function () {
  'use strict';

  function optimizeImages() {
    var images = document.querySelectorAll('.all-s img');
    if (!images.length) return;
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      if (!img.getAttribute('loading') && i > 3) img.setAttribute('loading', 'lazy');
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    }
  }

  function pauseOffscreenCarousels() {
    var carousels = document.querySelectorAll('.owl-carousel, .slick-slider');
    if (!carousels.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var el = entries[i].target;
        if (!entries[i].isIntersecting && window.jQuery) {
          var $el = window.jQuery(el);
          if ($el.hasClass('owl-carousel')) $el.trigger('stop.owl.autoplay');
          if ($el.hasClass('slick-slider') && $el.slick) $el.slick('slickPause');
        }
      }
    }, { rootMargin: '200px 0px' });
    for (var j = 0; j < carousels.length; j++) observer.observe(carousels[j]);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden || !window.jQuery) return;
    window.jQuery('.owl-carousel').trigger('stop.owl.autoplay');
    window.jQuery('.slick-slider').each(function () {
      if (this.slick) window.jQuery(this).slick('slickPause');
    });
  }, { passive: true });

  function init() {
    optimizeImages();
    pauseOffscreenCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
